export default "__VITE_ASSET__c070e77c__"